var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryReviewFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 16.6688H77.6007M16.0007 78.2688H77.6007M20.4007 3.46875H73.2007M20.0795 11.7716L24.3607 6.63675C25.6587 5.07915 26.3099 4.30035 27.1943 3.88235C28.0831 3.46875 29.0951 3.46875 31.1235 3.46875H62.4779C64.5019 3.46875 65.5183 3.46875 66.4071 3.88235C67.2915 4.30035 67.9427 5.07915 69.2407 6.63675L73.5219 11.7716C75.5415 14.196 76.5491 15.406 77.0771 16.858C77.6007 18.31 77.6007 19.8896 77.6007 23.04V71.8976C77.6007 75.048 77.6007 76.6276 77.0727 78.0796C76.5491 79.5316 75.5415 80.7416 73.5219 83.166L67.9207 89.8847C67.2695 90.6635 66.9483 91.0551 66.5039 91.2619C66.0639 91.4687 65.5535 91.4688 64.5415 91.4688H29.0599C28.0479 91.4688 27.5419 91.4687 27.0975 91.2619C26.6575 91.0551 26.3319 90.6635 25.6807 89.8847L20.0795 83.166C18.0599 80.7416 17.0523 79.5316 16.5243 78.0796C16.0007 76.6276 16.0007 75.048 16.0007 71.8976V23.04C16.0007 19.8896 16.0007 18.31 16.5287 16.858C17.0523 15.406 18.0599 14.196 20.0795 11.7716Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8007 58.4688C52.8759 58.4688 57.8007 53.5439 57.8007 47.4688C57.8007 41.3936 52.8759 36.4688 46.8007 36.4688C40.7256 36.4688 35.8007 41.3936 35.8007 47.4688C35.8007 53.5439 40.7256 58.4688 46.8007 58.4688Z",
    fill: "url(#paint0_linear_701_13946)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_13946",
    x1: 57.8007,
    y1: 48.904,
    x2: 39.6225,
    y2: 56.5523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryReviewFilled);
export default __webpack_public_path__ + "static/media/category-review-filled.ee3e1c425a06f36dc2853d0fde39c971.svg";
export { ForwardRef as ReactComponent };